import { render, staticRenderFns } from "./AttributeDetailPanel.vue?vue&type=template&id=467abae5"
import script from "./AttributeDetailPanel.vue?vue&type=script&lang=js"
export * from "./AttributeDetailPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports